function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  }
  const domain =
    location.hostname == 'localhost'
      ? ''
      : ';domain=.' + location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
  const security = location.hostname == 'localhost' ? '' : ';SameSite=None; Secure';
  document.cookie = name + '=' + value + expires + ';path=/' + domain + security;
}
if (pricing.getQueryString('modal') !== null) {
  setCookie('modal', pricing.getQueryString('modal'));
}

(function () {
  const lgr = readCookie('lgr');
  const modal = readCookie('modal');
  const welcomeModalClosed = readCookie('welcomeModalClosed');
  const welcomeModalEl = document.getElementById('offer-modal');
  const welcomeModal = new bootstrap.Modal(welcomeModalEl);

  if (lgr == '0f4ce4f7-9e5a-472f-b918-da6ed55a9264' && modal == 'welcome') {
    document.getElementById('welcome-banner').style.display = 'block';
    if (!welcomeModalClosed) {
      welcomeModal.show();
      welcomeModalEl.addEventListener('hidden.bs.modal', () => {
        setCookie('welcomeModalClosed', true);
      });
    }
  }
})();
